import tables from './tables';
import utils from '../utils';

const getAllActiveBrands = async (token) => {
  try {
    const { data } = await utils.getFromMikMakFirebaseService(
      `get/${tables.brands}?orderBy=isActive&equalTo=true`,
      token,
    );
    const brands = data.reduce((brands, brand) => {
      brands[brand.brandId] = brand;

      return brands;
    }, {});

    return brands;
  } catch (e) {
    throw `Error requesting brands: ${e.message}`;
  }
};

const getAllInactiveBrands = async (token) => {
  try {
    const { data } = await utils.getFromMikMakFirebaseService(
      `get/${tables.brands}?orderBy=isActive&equalTo=false`,
      token,
    );
    const brands = data.reduce((brands, brand) => {
      brands[brand.brandId] = brand;

      return brands;
    }, {});

    return brands;
  } catch (e) {
    throw `Error requesting brands: ${e.message}`;
  }
};
const getBrandByName = async (name, token) => {
  try {
    const { data: brand } = await utils.getFromMikMakFirebaseService(
      `get/${tables.brands}?orderBy=brandName&equalTo=${name}`,
      token,
    );

    return brand;
  } catch (e) {
    throw `Error getting brand by name ${name}: ${e}`;
  }
};
const getBrandById = async (id, token) => {
  try {
    const { data: brand } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.brands}/${id}`,
      token,
    );

    return brand;
  } catch (e) {
    throw `Error getting brand by id ${id}: ${e}`;
  }
};

const setBrand = async (brandObject, token) => {
  try {
    const { brandId } = brandObject;

    await utils.postToMikMakFirebaseService(`set/${tables.brands}/${brandId}`, brandObject, token);
    await utils.callProductService(`refreshLivePlayerDataForBrand?brandId=${brandId}`);

    return brandObject;
  } catch (e) {
    throw `Error creating brand: ${e}`;
  }
};

const updateBrand = async (brandObject, token) => {
  try {
    const { brandId } = brandObject;

    await utils.postToMikMakFirebaseService(`update/${tables.brands}/${brandId}`, brandObject, token);
    await utils.callProductService(`refreshLivePlayerDataForBrand?brandId=${brandId}`);

    return brandObject;
  } catch (e) {
    throw `Error creating brand: ${e}`;
  }
};

const setStagedAmazonBrand = async (brandObject, token) => {
  try {
    const { id_country } = brandObject;

    await utils.postToMikMakFirebaseService(
      `set/${tables.brandStaging_amazon}/${id_country}`,
      brandObject,
      token,
    );

    return brandObject;
  } catch (e) {
    throw `Error updating brand in Amazon staging table: ${e}`;
  }
};

const updateDiscoverBrandSettings = async (brandObject, data, token) => {
  try {
    const { brandId } = brandObject;

    await utils.postToMikMakFirebaseService(
      `update/${tables.brands}/${brandId}`,
      { embed: data },
      token,
    );

    return brandId;
  } catch (e) {
    throw `Error creating brand: ${e}`;
  }
};

const getAllActivePortfolios = async (token) => {
  try {
    const { data: portfolioData } = await utils.getFromMikMakFirebaseService(
      `get/${tables.portfolios}?orderBy=active&equalTo=true`,
      token,
    );

    return portfolioData;
  } catch (e) {
    throw `Error retrieving portfolios ${e.message}`;
  }
};

const setPortfolio = async (portfolio, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `set/${tables.portfolios}/${portfolio.id}`,
      portfolio,
      token,
    );
  } catch (e) {
    throw `Error setting portfolio ${e.message}`;
  }
};

export default {
  getAllActiveBrands,
  getAllInactiveBrands,
  setBrand,
  updateBrand,
  setStagedAmazonBrand,
  getBrandById,
  getAllActivePortfolios,
  setPortfolio,
  updateDiscoverBrandSettings,
  getBrandByName,
};
